import { useEffect } from 'react';
import { Hub } from 'aws-amplify/utils';
import {
  POST_SSO_REDIRECT_KEY,
  isSafeInternalPath
} from '../utils/ssoRedirect';

// Captures the destination carried through the OAuth redirect (set from the
// ?next= param on the login page) so it can be applied after sign-in. It only
// stores the value; PublicRoute consumes and clears it on the next public-route
// render. Storing here (rather than navigating) avoids leaving a stale redirect
// key behind when the callback lands somewhere PublicRoute doesn't run.
export const AuthRedirectListener = () => {
  useEffect(() => {
    return Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'customOAuthState') {
        const next = payload.data;
        if (isSafeInternalPath(next)) {
          sessionStorage.setItem(POST_SSO_REDIRECT_KEY, next);
        }
      }
    });
  }, []);

  return null;
};
